module.exports = __webpack_public_path__ + "img/grab_charge_logo.e76456fc.png";